<template>
  <div class="editor scroll-vertical">
    <detail-item
      name="Name"
      imgName="circle">
      {{ user.name }}
    </detail-item>
    <detail-item
      name="uid"
      imgName="circle">
      {{ user.uid }}
    </detail-item>
    <detail-item
      name="uuid"
      imgName="circle">
      {{ user.uuid }}
    </detail-item>
  </div>
</template>

<script>
import DetailItem from '@/components/DetailItem.vue';

export default {
  name: 'AlertLogUser',
  components: {
    DetailItem,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>
